import { CanvasFactory } from 'content-creation-common/preview';
import { isNumber } from '../../../../util/numbers';
import {
  DEFAULT_CREATIVE_HEIGHT_PX,
  DEFAULT_CREATIVE_WIDTH_PX,
} from '../../../creative/constants';

const DEFAULT_OPTIONS = {
  height: DEFAULT_CREATIVE_HEIGHT_PX,
  width: DEFAULT_CREATIVE_WIDTH_PX,
};

class ClientCanvasFactory extends CanvasFactory {
  /**
   *
   * @param {{height:number, width: number}}options
   * @returns {HTMLCanvasElement|self.OffscreenCanvas}
   */
  getCanvas(options) {
    let canvas;
    const canvasOptions = { ...DEFAULT_OPTIONS, ...options };
    const { height: optHeight, width: optWidth } = canvasOptions;
    const height = isNumber(optHeight) ? optHeight : DEFAULT_CREATIVE_HEIGHT_PX;
    const width = isNumber(optWidth) ? optWidth : DEFAULT_CREATIVE_WIDTH_PX;

    // If OffscreenCanvas is available we gain a slight performance gain in rendering groups
    // and other canvas-centric layers (shapes, some text, etc).
    if ('OffscreenCanvas' in self) {
      // Attempt to get the context, some browsers only support webGL in Offscreen Canvas for now.
      try {
        canvas = new self.OffscreenCanvas(width, height); // `self.OffscreenCanvas` is here to avoid a weird lint issue
        canvas.getContext('2d');
        return canvas;
      } catch (ignoredError) {
        // Ignored for now
      }
    }

    // Create canvas from dom as usual.
    canvas = document.createElement('canvas');
    canvas.height = height;
    canvas.width = width;

    return canvas;
  }
}

export const clientCanvasFactory = new ClientCanvasFactory();
